// Typelizer digest 6f878b28881da178078975a1c5c972ff
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /learners/schools/:school_id/preference_templates/:preference_template_id/application/new */
  new: (
    params: { schoolId: string | number; preferenceTemplateId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/schools/:school_id/preference_templates/:preference_template_id/application/new', params, options),
    method: 'get',
  }),

  /** POST /learners/schools/:school_id/preference_templates/:preference_template_id/application */
  create: (
    params: { schoolId: string | number; preferenceTemplateId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/learners/schools/:school_id/preference_templates/:preference_template_id/application', params, options),
    method: 'post',
  }),
}
